import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=4bc7efa6&"
import script from "./FeedbackView.vue?vue&type=script&lang=js&"
export * from "./FeedbackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc7efa6')) {
      api.createRecord('4bc7efa6', component.options)
    } else {
      api.reload('4bc7efa6', component.options)
    }
    module.hot.accept("./FeedbackView.vue?vue&type=template&id=4bc7efa6&", function () {
      api.rerender('4bc7efa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/public/FeedbackView.vue"
export default component.exports